module.exports = __webpack_public_path__ + "img/2.c0325aa8.jpg";